import {imageMap} from "../../../images/imageMap.ts";
import JobLayout from "./JobLayout.tsx";
import {JobsPostings} from "../jobs.ts";

export default function JobCustomerService20250528() {
    return <JobLayout job={JobsPostings.CustomerService20250528}>
        <p>
            Hiper er mere end bare en internetudbyder &ndash; vi er en kultur.
            En flad organisation, hvor du kan bidrage med indsigt og innovative idéer, uanset hvor i organisationen du sidder.
            Vi er stolte af vores stærke sammenhold og uformelle samarbejde.
        </p>

        <h2 className={'heading heading--montserrat heading--left heading--smaller'}>
            Derfor leder vi efter dig, der vil være med til at gøre en forskel for vores kunder &ndash; og samtidig være en del af et stærkt fællesskab.
        </h2>

        <p>
            <img src={imageMap.jobs.two_employess_working} alt={'Et billede af Hipers medarbejdere.'}/>
        </p>

        <h2 className={'heading heading--montserrat heading--left heading--small'}>
            Dine opgaver som kundeservicemedarbejder:
        </h2>
        <ul className={'list list--bullet'}>
            <li>Kommunikere og rådgive vores kunder via telefon, mail og chat</li>
            <li>Hjælpe kunder med internet-relaterede problemstillinger</li>
            <li>Bidrage med idéer &ndash; din stemme er vigtig!</li>
            <li>Gøre det endnu sjovere at være en del af Hiper</li>
        </ul>

        <h2 className={'heading heading--montserrat heading--left heading--small'}>
            Hvad tilbyder Hiper?
        </h2>
        <ul className={'list list--bullet'}>
            <li>En fuldtidsstilling hvor timerne kan ligge fra 9-21 i hverdagene og 9-16 i weekenderne</li>
            <li>God kantine samt frisk frugt, snacks og selvfølgelig god kaffe</li>
            <li>Sundhedsforsikring via PFA og adgang til Nuudays medarbejderfordele</li>
            <li>Fast løn med mulighed for provision</li>
            <li>Hyggeligt samvær, sociale arrangementer og fredagsbar</li>
            <li>Gratis medarbejder-internet fra Hiper</li>
        </ul>

        <h2 className={'heading heading--montserrat heading--left heading--small'}>
            Sundhed & Samvær
        </h2>
        <p>
            Sundhed er en strategisk prioritet hos os.
            Vi tror på, at fysisk aktivitet styrker fællesskabet og giver energi og glæde i hverdagen.
            Derfor tilbyder vi crossfit, løb og styrketræning hver uge med dygtige trænere &ndash; et populært initiativ blandt vores kollegaer.
            Og ja, vi er også ret gode til fredagsbarer.
        </p>

        <h2 className={'heading heading--montserrat heading--left heading--small'}>
            Fysisk lokation:
        </h2>
        <p>
            Teglholmsgade 1 i København SV, hvor Nuuday har hovedkontor, som Hiper er ejet af.
        </p>

        <h2 className={'heading heading--montserrat heading--left heading--small'}>
            Klar til næste skridt?
        </h2>
        <p>
            Har du spørgsmål &ndash; eller vil du søge stillingen &ndash; så send din ansøgning og CV til <a href={'mailto:job@hiper.dk'}>job@hiper.dk</a>.
            Vi glæder os til at høre fra dig!
        </p>
    </JobLayout>
}
